import { useMutation, useQuery } from "@tanstack/react-query";
import { OrganizationService } from "../../services"
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants";
import Noti from "../../view/components/general/noti";
import { handleResponse, queryClient } from "./setup";

const useGetOrganizations = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getOrganizations", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return OrganizationService.getOrganizationsList(params);
    },
    enabled: modalName ?? true
  });
}

const useGetOrganization = () => {
  return useMutation({
    mutationFn: OrganizationService.getOrganization,
  })
}

const useAddOrganization = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: OrganizationService.addOrganization,
    onSuccess: (data) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          navigate(ROUTES.ORGANIZATION.PATH);
        }
      })
    },
  })
}

const useDeleteOrganization = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: OrganizationService.deleteOrganization,
    onSuccess: (data) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getOrganizations"] })
          onSuccess();
        }
      })
    },
  })
}

const useGetRelatedOrganizations = (params: any) => {
  return useQuery({
    queryKey: ["getRelatedOrganizations", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return OrganizationService.getRelatedOrganizationsList(params);
    },
  });
}

const useAddRelatedOrganization = () => {
  return useMutation({
    mutationFn: OrganizationService.addRelatedOrganization,
    onSuccess: (data) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
        }
      })
    },
  })
}

export {
  useGetOrganizations,
  useGetOrganization,
  useAddOrganization,
  useDeleteOrganization,
  useGetRelatedOrganizations,
  useAddRelatedOrganization,
}
